<div class="container pt-4">
  <div class="row">
    <div class="breadcrumb col-12 order-lg-1 order-2">
      <div *ngIf="breadcrumbReady">
        <p-breadcrumb [model]="menuItems" [home]="home"></p-breadcrumb>
      </div>
    </div>
  </div>
</div>
